$(document).ready(function() {
  // Add CSS for the animation
  $('head').append(`
      <style>
          .member-destinations-top,
          .member-destinations-bottom {
              display: flex;
              position: relative;
              transition: all 0.3s ease;
              cursor: pointer;
              overflow: visible;
          }

          @keyframes scrollLeft {
              from { transform: translateX(0); }
              to { transform: translateX(-50%); }
          }

          @keyframes scrollRight {
              from { transform: translateX(-50%); }
              to { transform: translateX(0); }
          }

          .scroll-left {
              animation: scrollLeft 15s linear infinite;
          }

          .scroll-right {
              animation: scrollRight 15s linear infinite;
          }

          /* Pause animation when not hovering */
          .member-destinations-top:not(:hover) .scroll-left,
          .member-destinations-top:not(:hover) .scroll-right,
          .member-destinations-bottom:not(:hover) .scroll-left,
          .member-destinations-bottom:not(:hover) .scroll-right {
              animation-play-state: paused;
          }
      </style>
  `);

  // Clone the destinations to create continuous scroll effect
  $('.member-destinations-top').each(function() {
      const content = $(this).html();
      $(this).html(content + content);
  });

  $('.member-destinations-bottom').each(function() {
      const content = $(this).html();
      $(this).html(content + content);
  });

  // Add hover events
  $('.member-destinations-top').hover(
      function() {
          $(this).addClass('scroll-left');
      },
      function() {
          $(this).removeClass('scroll-left');
      }
  );

  $('.member-destinations-bottom').hover(
      function() {
          $(this).addClass('scroll-right');
      },
      function() {
          $(this).removeClass('scroll-right');
      }
  );
});